module.exports = __webpack_public_path__ + "img/3.c2f6a01f.jpg";